<template>

    <div class="bg-secondary py-5">

        <inertia-head title="Confirmed">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 600px;">
                    <div class="card rounded-3 shadow border-0">
                        <div class="card-body text-center">
                            <div class="mb-2">
                                <i class="bi bi-arrow-down-circle display-2 text-primary"></i>
                            </div>
                            <p>{{ __('Bitte klicken Sie auf den Button, um die Bestellung :order zu bestätigen.', {order: orderNumber}) }}</p>
                            <hr />
                            <inertia-link class="btn btn-lg btn-primary" href="." method="post">
                                {{ __('Confirm order') }}
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    export default {
        layout: SlimLayout,
        props: [
            'orderNumber',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        computed: {
        },
    }
</script>
